export const Facet = () => {
    function updateFacetResetButtons() {
        const fSelectFacets = document.querySelectorAll('.facetwp-type-fselect');

        fSelectFacets.forEach(function (facetEl) {
            const facetClass = Array.from(facetEl.classList).find((cls) => cls.startsWith('facetwp-facet-'));
            if (!facetClass) return;

            const facetName = facetClass.replace('facetwp-facet-', '');
            const fsLabelWrap = facetEl.querySelector('.fs-label-wrap');
            const fsLabel = facetEl.querySelector('.fs-label');
            const fsArrow = facetEl.querySelector('.fs-arrow');

            if (!fsLabelWrap || !fsArrow) return;

            const hasSelectedOption = !!facetEl.querySelector('.fs-options .fs-option.selected');
            const hasSelection = (typeof FWP !== 'undefined' && FWP.facets[facetName] && FWP.facets[facetName].length > 0) || hasSelectedOption;

            const existingReset = fsLabelWrap.querySelector('.fselect-reset-btn');
            if (existingReset) {
                existingReset.remove();
            }

            if (hasSelection) {
                fsArrow.style.display = 'none';
                fsLabel.style.background = 'var(--wp--preset--color--gold)';

                const resetBtn = document.createElement('button');
                resetBtn.type = 'button';
                resetBtn.className = 'fselect-reset-btn';
                resetBtn.innerHTML = '<span class="sr-only">Reset</span>';
                resetBtn.setAttribute('aria-label', 'Reset ' + facetName);
                resetBtn.setAttribute('data-facet', facetName);

                resetBtn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    FWP.reset(this.getAttribute('data-facet'));
                });

                fsLabelWrap.appendChild(resetBtn);
            } else {
                fsArrow.style.display = '';
                fsLabel.style.background = '';
            }
        });
    }

    document.addEventListener('facetwp-loaded', updateFacetResetButtons);

    // Run immediately in case facetwp-loaded already fired before this script registered
    if (typeof FWP !== 'undefined') {
        updateFacetResetButtons();
    }
};
